import {SmallBox} from '@app/components';
import React, {useEffect, useState} from 'react';
import ChartLineCollapsed from './graph/LineCollapsed';
import ChartLineCurvedCollapsed from './graph/LineCurvedCollapsed';
import ChartPieCollapsed from './graph/PieCollapsed';
import ChartRadarCollapsed from'./graph/RadarCollapsed';
import faker from 'faker';
import Card from 'react-bootstrap/Card';
import {Button, Form} from 'react-bootstrap';
import Select from 'react-select';
import {MonthPicker} from 'react-tempusdominus-bootstrap';
import * as AuthService from '../services/auth';
import {toast} from 'react-toastify';
import {PfButton} from '@profabric/react-components';
import {logoutUser} from '@store/reducers/auth';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {utils, write} from 'xlsx';
import FileSaver from 'file-saver';
const color = [
  {
    borderColor: 'rgb(255, 99, 132)',
    backgroundColor: 'rgba(255, 99, 132, 0.5)'
  },
  {
    borderColor: 'rgb(53, 162, 235)',
    backgroundColor: 'rgba(53, 162, 235, 0.5)'
  },
  {
    borderColor: 'rgb(255, 205, 86)',
    backgroundColor: 'rgba(255, 205, 86, 0.5)'
  },
  {
    borderColor: 'rgba(0, 123, 255, 1)',
    backgroundColor: 'rgba(0, 123, 255, 0.7)'
  }
];

const downloadXlsx = (input : any, name : any) => {
  try {
    const ws = utils.json_to_sheet(input);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Sheet1');
    const wbout = write(wb, {
      bookType: 'xlsx',
      bookSST: false,
      type: 'array'
    });
    FileSaver.saveAs(
      new Blob([wbout], {type: 'application/octet-stream'}),
      `${name}.xlsx`
    );
  } catch (err) {
    console.error('export error', err);
  }
};

const chartdata = {
  chart_name: 'Loading...',
  chart_labels: ['Loading...'],
  chart_datas: [
    {
      label: 'Loading...',
      data: [0]
    }
  ]
};

// const Dashboard = () => {
const Dashboard = React.forwardRef<HTMLInputElement>((props, ref) => {
  useEffect(() => {
    downloadDropdownWs();
    const token = localStorage.getItem("gatekeeper_token");
    if (token) downloadReportWsInit();
  }, []);
  const [dashboardData, setDashboardData] = useState<any>({
    dashboard2: {data: []},
    dashboard3: {data: []},
    dashboard4: {data: []},
    dashboard5: {data: []}
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [chartData1, setChartData1] = useState<any>(chartdata);
  const [chartData2, setChartData2] = useState<any[]>([]);
  const [chartData3, setChartData3] = useState<any[]>([]);
  const [chartData4, setChartData4] = useState<any>(chartdata);
  const [isLoading, setLoading] = useState(false);
  const [dropdownCountry, setDropdownCountry] = useState<any[]>([]);
  const [smallData, setSmallData] = useState<any>({
    user: 'Loading',
    userPercent: 'Loading',
    scan: 'Loading',
    redeem: [{TITLE: 'Loading', AMOUNT: 0}],
    remain: [{TITLE: 'Loading', AMOUNT: 0}],
  });
  const [state, setState] = useState({
    countryid: {value: '', label: ''},
    date_start: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
    date_end: new Date(new Date().getFullYear(), new Date().getMonth()+1, 0)
  });

  const downloadDropdownWs = async () => {
    try {
      const dropdowns = await AuthService.downloadDropdown();

      const countryDropdown = dropdowns.reduce(function (acc: any, curr: any) {
        if (curr.TYPE === 'COUNTRY') {
          delete curr.TYPE;
          return [...acc, curr];
        }
        return [...acc];
      }, []);

      setDropdownCountry(countryDropdown);
    } catch (error: any) {}
  };

  const downloadReportWs = async () => {
    setLoading(true);
    try {
      if (state.countryid.value === '') {
        toast.error('Select country.');
        setLoading(false);
      } else {
        let _date_start = new Date(state.date_start);
        let _date_end = new Date(state.date_end);

        const offset = _date_start.getTimezoneOffset();
        _date_start = new Date(_date_start.getTime() - offset * 60 * 1000);
        _date_end = new Date(_date_end.getTime() - offset * 60 * 1000);

        const params = await AuthService.downloadDashboard(
          _date_start.toISOString().split('T')[0],
          _date_end.toISOString().split('T')[0],
          state.countryid.value
        );
        if(params.error) throw "timeout";

        setDashboardData(params);
        console.log(params);

        const _chart01 = formatChart1(params);
        const _chart02 = formatChart2(params);
        const _box01 = formatBox1(params);
        setChartData1(_chart01);
        setChartData2(params.dashboard3.data.filter((e : any)=>{return e.TYPE === 'GENDER'}));
        setChartData3(params.dashboard4.data.filter((e : any)=>{return e.TYPE === 'AGE'}));
        setSmallData(_box01);//ปัญหา
        setChartData4(_chart02);
        setLoading(false);
      }
    } catch (error: any) {
      dispatch(logoutUser());
      navigate('/login');
    }
  };

  const formatChart1 = (params: any) => {
    try {
      let _chart1: any = {
        chart_name: params.dashboard2.name,
        chart_labels: [],
        chart_datas: []
      };
      let _label1 = {...params.dashboard2.data[0]};
      delete _label1.TITLE;
      delete _label1.TYPE;
      _chart1 = {..._chart1, chart_labels: Object.keys(_label1)};

      let i = 0;
      params.dashboard2.data.forEach((element : any) => {
        const _title = element.TITLE;
        const _data = {...element};
        delete _data.TITLE;
        delete _data.TYPE;
        const _temp = {
          label: _title,
          data: Object.values(_data),
          tension: 0.4,
          ...color[i]
        };
        i++;
        _chart1.chart_datas.push(_temp);
      });

      return _chart1;
    } catch {}
  };

  const formatChart2 = (params: any) => {
    try {
      let _chart1: any = {
        chart_name: params.dashboard5.name,
        chart_labels: [],
        chart_datas: []
      };
      let _label1 = {...params.dashboard5.data[0]};
      delete _label1.MONTH;
      delete _label1.TYPE;
      _chart1 = {..._chart1, chart_labels: Object.keys(_label1)};

      let i = 0;
      params.dashboard5.data.forEach((element : any) => {
        const _title = "Registration";
        const _data = {...element};
        delete _data.MONTH;
        delete _data.TYPE;
        const _temp = {
          label: _title,
          data: Object.values(_data),
          tension: 0.4,
          fill: true,
          ...color[3]
        };
        i++;
        _chart1.chart_datas.push(_temp);
      });

      return _chart1;
    } catch {}
  };

  const formatBox1 = (params: any) => {
    try {
      let _box1: any = {
        user: 'Loading',
        userPercent: 'Loading',
        scan: 'Loading',
        redeem: [],
        remain: []
      };

      _box1.user = params.dashboard1.data.find(
        (e: any) => e.TYPE === 'USER'
      ).AMOUNT;
      _box1.userPercent = params.dashboard1.data.find(
        (e: any) => e.TYPE === 'USER'
      ).TITLE;
      _box1.scan = params.dashboard1.data.find(
        (e: any) => e.TYPE === 'SCAN'
      ).AMOUNT;

      _box1.redeem = params.dashboard1.data.filter((e) => {
        return e.TYPE === 'REDEEM';
      });

      _box1.remain = params.dashboard1.data.filter((e) => {
        return e.TYPE === 'REMAIN';
      });

      return _box1;
    } catch {
      return {
        user: '',
        scan: '',
        redeem: [],
        remain: []
      };
    }
  };

  const downloadReportWsInit = async () => {
    try {
      const params = await AuthService.downloadDashboard('', '', '');
      if(params.error) throw "timeout";

      setDashboardData(params);
      console.log(params);

      const _chart01 = formatChart1(params);
      const _chart02 = formatChart2(params);
      const _box01 = formatBox1(params);
      setChartData1(_chart01);
      setChartData2(params.dashboard3.data.filter((e : any)=>{return e.TYPE === 'GENDER'}));
      setChartData3(params.dashboard4.data.filter((e : any)=>{return e.TYPE === 'AGE'}));
      setSmallData(_box01);
      setChartData4(_chart02);
    } catch (error: any) {
      dispatch(logoutUser());
      navigate('/login');
    }
  };

  return (
    <div ref={ref}>
      <section className="content">
        <div className="container-fluid">
          <Card className="card">
            <Card.Body>
              <div className="row col-md-12">
                <Form.Group className="mb-3 col-md-3">
                  <Form.Label>Select Country</Form.Label>
                  <Select
                    options={dropdownCountry}
                    id="countryid"
                    onChange={(v: any) =>
                      setState((prevState) => ({...prevState, countryid: v}))
                    }
                  />
                </Form.Group>
                <Form.Group className="mb-3 col-md-3">
                  <Form.Label>Select Date Range</Form.Label>
                  <div className="row">
                    <div className="mb-3 col-md-12">
                      <MonthPicker
                        format="MM/YYYY"
                        date={state.date_start}
                        onChange={(e: any) => {
                          var date = new Date(e.date);
                          var y = date.getFullYear(),
                            m = date.getMonth();
                          console.log(y);
                          console.log(m);
                          var firstDay = new Date(y, m, 1);
                          var lastDay = new Date(y, m + 1, 0);
                          setState((prevState) => ({
                            ...prevState,
                            date_start: firstDay,
                            date_end: lastDay
                          }));
                        }}
                      />
                    </div>
                  </div>
                </Form.Group>
                <Form.Group className="mb-3 col-md-2">
                  <Form.Label>&nbsp;</Form.Label>
                  <Button block onClick={downloadReportWs}>
                    {isLoading ? 'Loading ...' : 'Submit'}
                  </Button>
                  {/* <PfButton
                    block
                    onClick={downloadReportWs}
                    loading={isLoading}
                  >
                    Submit
                  </PfButton> */}
                </Form.Group>
              </div>
            </Card.Body>
          </Card>
          <div className="row">
            <div className="col-lg-3 col-6">
              <div className="small-box bg-info">
                <div className="inner">
                  <h3>
                    <label>
                      {smallData.user}
                      <sup>(<i className={smallData.userPercent.includes('-') ? 'fas fa-arrow-down' : 'fas fa-arrow-up'}></i> {smallData.userPercent})</sup>
                    </label>
                  </h3>

                  <p>New Customers</p>
                </div>
                <div className="icon">
                  <i className="ion ion-person-add" />
                </div>
                <a href="/" className="small-box-footer">
                  More info <i className="fas fa-arrow-circle-right" />
                </a>
              </div>
            </div>
            <div className="col-lg-3 col-6">
              <div className="small-box bg-success">
                <div className="inner">
                  <h3>
                    {smallData.redeem.map((e) => (
                      <label>
                        {e.AMOUNT}
                        <sup>({e.TITLE})</sup>
                      </label>
                    ))}
                  </h3>

                  <p>Redeemed Vouchers</p>
                </div>
                <div className="icon">
                  <i className="ion ion-bag" />
                </div>
                <a href="/" className="small-box-footer">
                  More info <i className="fas fa-arrow-circle-right" />
                </a>
              </div>
            </div>
            <div className="col-lg-3 col-6">
              <div className="small-box bg-warning">
                <div className="inner">
                  <h3>
                    <label>{smallData.scan}</label>
                  </h3>

                  <p>QR Scans</p>
                </div>
                <div className="icon">
                  <i className="ion ion-qr-scanner" />
                </div>
                <a href="/" className="small-box-footer">
                  More info <i className="fas fa-arrow-circle-right" />
                </a>
              </div>
            </div>
            <div className="col-lg-3 col-6">
              <div className="small-box bg-danger">
                <div className="inner">
                  <h3>
                    {smallData.remain.map((e) => (
                      <label>
                        {e.AMOUNT}
                        <sup>({e.TITLE})</sup>
                      </label>
                    ))}
                  </h3>
                  <p>Remaining Vouchers</p>
                </div>
                <div className="icon">
                  <i className="ion ion-pie-graph" />
                </div>
                <a href="/" className="small-box-footer">
                  More info <i className="fas fa-arrow-circle-right" />
                </a>
              </div>
            </div>

            <div className="col-md-6 col-sm-12 col-12">
              <ChartLineCollapsed
                chartdata={chartData1}
                csvdata={dashboardData.dashboard2.data}
                export={downloadXlsx}
              />
            </div>

            <div className="col-md-6 col-sm-12 col-12">
            <ChartLineCurvedCollapsed
                chartdata={chartData4}
                csvdata={dashboardData.dashboard5.data}
                export={downloadXlsx}
              />
            </div>

            <div className="col-md-6">
              <ChartPieCollapsed
                chartdata={chartData2}
                chartname={dashboardData.dashboard3.name}
                csvdata={dashboardData.dashboard3.data.filter((e : any)=>(e.TYPE === 'GENDER'))}
                export={downloadXlsx}
              />
            </div>

            <div className="col-md-6">
              <ChartRadarCollapsed
                chartdata={chartData3}
                chartname={dashboardData.dashboard4.name}
                csvdata={dashboardData.dashboard4.data.filter((e : any)=>(e.TYPE === 'AGE'))}
                export={downloadXlsx}
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
});

export default Dashboard;
